'use client'

export function PlanCard({
  title,
  price,
  period,
  desc,
  highlight = false,
  badge,
  onClick,
  features = [],
  meta,
}: any) {
  return (
    <div
      onClick={onClick}
      className={`relative flex cursor-pointer flex-col gap-6 rounded-[32px] border-2 p-8 transition-all group ${
        highlight
          ? 'scale-[1.02] border-zinc-900 bg-zinc-900 text-white shadow-2xl'
          : 'border-zinc-100 bg-white shadow-sm hover:border-[#FACC15]'
      }`}
    >
      {badge && (
        <span className="absolute -top-3 right-8 rounded-full bg-[#FACC15] px-4 py-1 text-[9px] font-black uppercase tracking-widest text-black shadow-xl">
          {badge}
        </span>
      )}

      <div className="flex flex-col gap-1">
        <span
          className={`text-sm font-black uppercase tracking-widest ${
            highlight ? 'text-[#FACC15]' : 'text-zinc-400'
          }`}
        >
          {title}
        </span>

        <div className="flex items-baseline gap-1">
          <span className="text-4xl font-black tracking-tighter">{price}</span>
          <span className="text-sm font-medium opacity-50">{period}</span>
        </div>
      </div>

      <p
        className={`text-sm font-medium leading-relaxed ${
          highlight ? 'text-zinc-400' : 'text-zinc-500'
        }`}
      >
        {desc}
      </p>

      {meta && (
        <div className={`text-[10px] font-black uppercase tracking-widest ${
            highlight ? 'text-zinc-500' : 'text-zinc-400'
        }`}>
            {meta}
        </div>
        )}

        {!!features.length && (
        <ul className="space-y-2">
            {features.map((feature: string, index: number) => (
            <li
                key={index}
                className={`text-xs font-bold ${
                highlight ? 'text-zinc-400' : 'text-zinc-500'
                }`}
            >
                • {feature}
            </li>
            ))}
        </ul>
      )}

      <button
        className={`w-full rounded-2xl py-4 text-sm font-black transition-all ${
          highlight
            ? 'bg-[#FACC15] text-black hover:scale-[1.02]'
            : 'bg-zinc-100 text-zinc-900 group-hover:bg-[#FACC15]'
        }`}
      >
        Elegir {title.toLowerCase()}
      </button>
    </div>
  )
}